// Semnalele de eroare, într-un singur loc.
//
// Nu e un context React, ci un mic emițător de modul, DELIBERAT: clientul de
// API (`api.ts`) nu e o componentă și nu poate folosi un hook, iar exact acolo
// trebuie prinse erorile de server — altfel fiecare ecran ar trebui să-și
// amintească singur să afișeze ceva, și unul o va uita.

/** `lucru` = ceva în curs: toastul poartă o bulină care pulsează şi stă
 *  cât ţine treaba, nu cele 7 secunde. */
export type Fel = "eroare" | "info" | "lucru";
export type Toast = { id: number; mesaj: string; fel: Fel };

let urmatorId = 1;
let toasturi: Toast[] = [];
const abonati = new Set<(t: Toast[]) => void>();

function emite() {
  const copie = [...toasturi];
  abonati.forEach((f) => f(copie));
}

/** Arată un toast și întoarce id-ul lui, ca cine l-a pus să-l poată stinge
 *  înainte de vreme (un «se pregătește…» stins când s-a terminat).
 *  `durataMs` null = nu se stinge singur: pentru un «se salvează…» care ține
 *  cât ține cererea, nu 7 secunde — cine l-a pus îl stinge. */
export function arata(mesaj: string, fel: Fel = "eroare", durataMs: number | null = 7000): number {
  // Același mesaj de două ori la rând (două cereri care pică împreună) e un
  // singur semnal pentru om, nu două.
  const deja = toasturi.find((t) => t.mesaj === mesaj);
  if (deja) return deja.id;
  const toast = { id: urmatorId++, mesaj, fel };
  toasturi = [...toasturi, toast];
  emite();
  if (durataMs != null) setTimeout(() => inchide(toast.id), durataMs);
  return toast.id;
}

export function inchide(id: number) {
  toasturi = toasturi.filter((t) => t.id !== id);
  emite();
}

export function aboneaza(f: (t: Toast[]) => void) {
  abonati.add(f);
  f([...toasturi]);
  return () => { abonati.delete(f); };
}
